import { render, staticRenderFns } from "./ServicesPage.vue?vue&type=template&id=05d7daf6&scoped=true"
import script from "./ServicesPage.vue?vue&type=script&lang=js"
export * from "./ServicesPage.vue?vue&type=script&lang=js"
import style0 from "./ServicesPage.vue?vue&type=style&index=0&id=05d7daf6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d7daf6",
  null
  
)

export default component.exports